import React from 'react';

export function Assessment () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <g clipPath="url(#clip0_18974_12475)">
        <g
          stroke="#717171"
          strokeLinecap="round"
          strokeLinejoin="round"
          clipPath="url(#clip1_18974_12475)"
        >
          <path d="M8 7V1M14 7V1M20 7V1M25 4H3a2 2 0 00-2 2v19a2 2 0 002 2h22a2 2 0 002-2V6a2 2 0 00-2-2zM7 14h14M7 20h8" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18974_12475">
          <path fill="#fff" d="M0 0H28V28H0z" />
        </clipPath>
        <clipPath id="clip1_18974_12475">
          <path fill="#fff" d="M0 0H28V28H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
